import { render, staticRenderFns } from "./Educacao.vue?vue&type=template&id=6174480c&scoped=true&lang=pug&"
import script from "./Educacao.vue?vue&type=script&lang=js&"
export * from "./Educacao.vue?vue&type=script&lang=js&"
import style0 from "./Educacao.styl?vue&type=style&index=0&id=6174480c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6174480c",
  null
  
)

export default component.exports